module.exports = __webpack_public_path__ + "img/shoes.7a4e3fc3.jpg";